const DB_PREFIX = 'database/';

export function parentDirOfMarkdown(path: string): string {
  const i = path.lastIndexOf('/');
  return i >= 0 ? path.slice(0, i) : DB_PREFIX.replace(/\/$/, '');
}

export function slugFromLabel(label: string): string {
  return label
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

export function displayNameFromPath(path: string): string {
  const base = path.split('/').pop()!.replace('.md', '');
  return base.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

/** Unique folder paths that contain markdown (includes `database`). */
export function listDatabaseFolders(allPaths: string[]): string[] {
  const dirs = new Set<string>(['database']);
  for (const p of allPaths) {
    if (!p.startsWith(DB_PREFIX) || !p.endsWith('.md')) continue;
    const rel = p.slice(DB_PREFIX.length);
    const segments = rel.split('/').filter(Boolean);
    segments.pop();
    let acc = 'database';
    for (const seg of segments) {
      acc = `${acc}/${seg}`;
      dirs.add(acc);
    }
  }
  return [...dirs].sort((a, b) => a.localeCompare(b));
}

export function folderLabel(dir: string): string {
  if (dir === 'database') return 'database (root)';
  return dir.replace(/^database\//, '');
}
